import httpClient from '@gateway/generalHttpRequest'
import { adapterContent } from './adapter-content'

export const getContent = async (materialId: string) => {
  const path = `/contents/api/v1/complementary_content/?material_id=${materialId}`
  const response = await httpClient.get(path)
  const responseJson = await response.json()
  return adapterContent(responseJson)
}
